module.exports = __webpack_public_path__ + "static/media/Reachablemenu720.ec4e637c.m4v";